import { useApiClient } from "../../../api";
import { useEffect, useState } from "react";

export const useVerifyUploadToken = ({
  user,
  token,
  assignmentQuestion,
  setAnswers,
  studentCreatedToken = false,
}) => {
  const ApiClient = useApiClient();

  const [studentInputSettings, setStudentInputSettings] = useState(null);
  const [checkingToken, setCheckingToken] = useState(true);
  const [tokenIsValid, setTokenIsValid] = useState(false);
  const [tokenErrorMessage, setTokenErrorMessage] = useState("");

  const [identifiers, setIdentifiers] = useState([]);
  const [isIndependentUser, setIsIndependentUser] = useState(false);

  const verifyUploadToken = async () => {
    setCheckingToken(true);

    try {
      const response = await ApiClient.assignment.verifyUploadToken({
        user,
        assignmentQuestion,
        token,
        studentCreatedToken,
      });

      if (response.success && response.isValid) {
        setStudentInputSettings(response.studentInputSettings || {});
        setTokenIsValid(true);
        setIdentifiers(response.students);
        setAnswers(response.answers);
      } else {
        setTokenIsValid(false);
        setTokenErrorMessage(
          response.message || "Invalid upload URL or credentials",
        );
      }

      setIsIndependentUser(response.isIndependentUser);
    } catch (error) {
      console.error(error);
      setTokenIsValid(false);
      setTokenErrorMessage("Unable to verify upload link.");
    } finally {
      setCheckingToken(false);
    }
  };

  useEffect(() => {
    if (user && token) {
      verifyUploadToken();
    } else {
      setTokenErrorMessage(
        "Invalid upload link or the link has expired. Please request a new one.",
      );
      setCheckingToken(false);
    }
  }, [user, token]);

  return {
    studentInputSettings,
    checkingToken,
    tokenIsValid,
    tokenErrorMessage,
    identifiers,
    isIndependentUser,
    verifyUploadToken,
  };
};
